import gsap from 'gsap';
import { Container, Sprite } from 'pixi.js';
import { Coordinates } from './declarations/PositionInfo';

const IN_DURATION = 0.2;
const OUT_DURATION = 0.2;

export default class Fader extends Container {
  private flash: Sprite;

  constructor() {
    super();

    this.flash = Sprite.from(`flash.png`);
    this.flash.anchor.set(0.5);
    this.addChild(this.flash);
    this.eventMode = 'none';
    this.alpha = 0;
    this.scale.set(0.3);
  }

  fadeInOut(position: Coordinates) {
    this.position = position;

    gsap.to(this, {
      duration: IN_DURATION,
      pixi: {
        scale: 0.7,
        alpha: 0.8,
      },
      //ease: 'sine.out',
      onComplete: () => {
        gsap.to(this, {
          duration: OUT_DURATION,
          pixi: {
            scale: 0.3,
            alpha: 0,
          },
        });
      },
    });
  }
}
